import Vue from 'vue'
import FileTransformer from '../../transformers/Files/Files'

export default (payload) => {
  const tData = FileTransformer.send(payload)

  return Vue.$http.post('/catalogs/common/file/', tData)
    .then((response) => FileTransformer.fetch(response.data))
  .catch((err) => { throw err })
}


// WEBPACK FOOTER //
// ./src/services/Files/create.js